<div class="flex flex-col">
  <div class="flex items-center">
    <div class="align-baseline">
      <span class="mr-3 self-end body-mention text-grey-dark60" *ngIf="start">{{ start }}</span>
      <span class="h4 text-grey-dark align-baseline">{{ formattedAmount }} {{ currency }}</span>
      <span class="ml-3 self-end body-mention text-grey-dark60" *ngIf="end">{{ end }}</span>
    </div>
  </div>
  <div *ngIf="text">
    <span class="block self-end body-mention text-grey-dark60">{{ text }}</span>
  </div>
</div>
